module.exports = __webpack_public_path__ + "media/images/frontend/pages/home-5-8786a2bbbf5a8d8a448e34db8504eca8.jpg";